import { BrandLiabilityCompensationBanner } from '../components/BrandLiabilityCompensationBanner';
import { useBrandLiabilityCompensationBannerService } from '../services/useBrandLiabilityCompensationBannerService';

export const BrandLiabilityCompensationBannerContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { parallel_imported_banner_image_url } = useBrandLiabilityCompensationBannerService();

  if (!parallel_imported_banner_image_url) {
    return null;
  }
  return <BrandLiabilityCompensationBanner parallel_imported_banner_image_url={parallel_imported_banner_image_url} />;
};
